export const APPOINTMENT_LABEL = 'Appointment may be required to visit';
export const HOURS_VARY_LABEL = 'Hours may vary seasonally';
export const PERMANENTLY_CLOSED_MODAL_BODY =
  'Are you positive this place is closed for good? It will no longer be available when searching Boone.';
export const EDIT_DATE_FORMAT = 'YYYY-MM-DD';
export const VIEW_DATE_FORMAT = 'MMMM D, YYYY';
